import React from "react";
import Modal from "../../Components/Modal/Modal";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";

function SignUpCollegePopUp(props) {
  return (
    <Modal
      className="w-50"
      header="Quick check"
      onClose={props.onClose}
      show={props.show}
    >
      <p className="center-text fs-20">
        Are you a teacher or do you want to work as Teacher?
      </p>
      <br />
      <div className="row mt-5">
        <div className="col-md-6 mb-2 mb-md-0">
          <CancelButton onClick={props.onAnswerYes}>Yes</CancelButton>
        </div>
        <div className="col-md-6">
          <ConfirmButton onClick={props.onAnswerNo}>No</ConfirmButton>
        </div>
      </div>
    </Modal>
  );
}

export default SignUpCollegePopUp;
